// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__wT8Av","normal":"styles_normal___2E9a","small":"styles_small__K911D"};